import * as React from 'react';
import { Field } from 'react-final-form';

export interface IHiddenFieldProps {
    fieldName: string;
}

/**
 * Provides a hidden final-form field.
 * @param props
 */
const HiddenField: React.FunctionComponent<IHiddenFieldProps> = (props) => {

    const renderFunc = React.useCallback(() => null, []);

    return (
        <Field
            name={props.fieldName}
            type="input"
            render={renderFunc}
        />
    );
};

export default HiddenField;